<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <wc-data-box
            title='All Estimates'
            :titleIcon='$store.state.icons.modules.estimates.icon'
            :titleIconColor='$store.state.icons.modules.estimates.iconColor'
            showSearch
            v-model='search'
          >
            <v-data-table
              :loading='isLoading'
              dense
              sort-by='estimate_date'
              :search='search'
              :items='estimates'
              :headers='headers'
              @click:row='openEstimate'
              :items-per-page='-1'
              hide-default-footer
            >
              <template v-slot:item.start_date='{ item }'>
                {{ item.estimate_date | shortDate }}
              </template>
              <template v-slot:item.end_date='{ item }'>
                {{ item.sold_date | shortDate }}
              </template>
              <template v-slot:item.division='{ item }'>
                <span v-if='item.division'>
                  <wc-division-nai :division_obj='fullDiv(item.division)'></wc-division-nai>
                </span>
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import clientsAPI from '@/modules/clients/api/clients'
import _ from 'lodash'

export default {
  name: 'client-projects',
  props: {
    client: {
      required: true
    }
  },
  data: () => ({
    search: "",
    estimates: [],
    temp: [],
    isLoading: true,
    headers: [
      { text: 'Estimate Name', value: 'name', width: '150' },
      { text: 'Number', value: 'number', width: '200' },
      { text: 'Site Address', value: 'site_address' },
      { text: 'Division', value: 'division', align: 'center' },
      { text: 'Estimate Date', value: 'estimate_date' },
      { text: 'Date Booked', value: 'sold_date' }
    ],
  }),
  created () {
    this.getEstimates ()
  },
  computed: {
    divs () {
      return _.orderBy(this.$store.state.misc.divisions, 'order')
    }
  },
  methods: {
    openEstimate (item) {
      // Will need to be adjusted depending on the Division of the estimate
      this.$router.push({ name: item.division_obj.division + 'Estimate', params: { id: item.id } })
    },
    fullDiv (divisionNumber) {
      return _.find(this.divs, ['id', divisionNumber])
    },
    async getEstimates () {
      this.isLoading = true
      // this will eventually need a conditional in order to account for different division project displays
      this.estimates = await clientsAPI.getClientEstimates(this.client.id)
      this.isLoading = false
    }
  }
}
</script>
